module.exports = __webpack_public_path__ + "img/Kila Panchot.67ad1301.jpg";